<template lang="pug">
  .modal-backdrop
    .modal
      header.modal-header
        slot(name="header")
          | {{ currentSessionName ?  currentSessionName : `Sesion N॰ ${sessionsthisyear + 1}` }} {{ userevaluated ? userevaluated.name : ''}}
        button(
          type="button"
          class="btn-close"
          @click="close")
            | x

      section.modal-body(style="overflow: auto; max-height: 100vh;")
        slot(name="body")
          .row
            .col-8
              span.h4.font-italic Kpi
            .col-2
            
            .col-2
              span foco
          .row(v-for="k in kpiext")
            .col-8
              .d-flex.row.form-group.align-items-end.mb-1
                .col
                  a()
                    i.icon-letters.icon-letters__viaje.mr-2 V
                    i.icon-letters.icon-letters__producto.mr-2 P
                    i.icon-letters.icon-letters__segmento.mr-2 S
                  b-tooltip(placement='top')
                    | 
                  a()
                    i.icon-letters.icon-letters__negocio.mr-1 N
                  b-tooltip(placement='top')
                    | 
                  | {{k.name}}
                .col-auto
                  p.d-inline-block.mb-0.ad_text-grayMedio
                    sup Meta
                    span {{k.goal}} %
            .col-2
              .input-refresh.d-flex.flex-row.align-items-center.ml-2
                input(v-model="k.value", type="text", label='%', max='100', maxlength='3')
                | %
            .col-2
              input.form-checkbox.text-none(v-model="k.isFocused", type="checkbox", label="")
          hr.my-4
          .row
            .col-4
              span Competencias
            .col-4
              span Conductas
            .col-2
              span Evaluacion
            .col-2
          div(v-for="category in evaluations")
            div(v-for="e in category.evaluations")
              .row
                .col-4
                  span {{category.category.name}}
                .col-4
                  span {{e.evaluation}} 
                .col-2
                  .ad_select
                    select(v-model="e.result_name")
                      option(:value="null" selected) 
                      option(:value="s", v-for="s in scalevalues", :key="s._id") {{s.name}}
                .col-2
                  input.form-checkbox.text-none(v-model="e.isFocused", type="checkbox", label="")
          hr.my-4
          .row
            .col-2
              small.d-block 
            .col-10
              .dialog-box
                textarea.form-control(v-model="minute", rows="10", placeholder='ingresa minuta', title='Minuta')
                .col-auto.form-group.align-items-center.mb-0.pr-0
          .row(v-for="l in lastsessions.docs")
            .col-2
              small.d-block {{l.minutes.date_created | DateFormat}}
            .col-10
              .dialog-box
                p {{l.minutes.text}}
      footer.modal-footer
        //- slot(name="footer")
        //-   | This is the default footer!
        .row
          button.btn.btn-secondary-border.auto(type='submit', @click='close') Volver
          button.btn.btn-primary-border.auto(type="button" @click="addSession") Guardar

    b-modal(:id='errorModal.id',centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
        <template v-slot:modal-title>
          h3.font-weight-bold.mb-0 {{errorModal.title}}
        </template>
          .col.px-0.ad_select
            | {{errorModal.message}}
        <template v-slot:modal-footer="{ ok, cancel, hide }">
          .col-12.d-flex.justify-content-around
              b-button.px-4(size="lg", variant="danger", @click="$bvModal.hide(infoModal.id)")
                | No
        </template> 
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'ModalSession',
    props: ['userevaluated', 'evaluations', 'scalevalues', 'lastsessions', 'kpiext', 'user', 'sessionsthisyear', 'currentSessionName'],
    data() {
      return {
        guidelines: [],
        minute: null,
        errorModal: {
          id: 'error-session',
          title: '¡Aviso!',
          message: ''
        }
      }
    },
    methods: {
      ...mapActions("session", ["getMyTeamSessions", "createSession"]),
      ...mapActions('kpi', [
        'kpiByIds', 'kpiBySegTraProRole'
      ]),
      ...mapActions('role', [
        'byTriplets', 'roleByIds'
      ]),
      close() {
        this.$emit('close');
      },
      addSession() {  
        const loading = this.$toast.loading('Guardando...')
        this.validateForm().then(() => {    
          this.createSession({evaluations: this.evaluations, kpiext: this.kpiext, minute: this.minute, user: this.user.id, user_evaluated: this.userevaluated._id, name: `Sesion N॰ ${ this.sessionsthisyear + 1 }`}).then(() => {
            this.$emit('close');
            loading.hide();
            this.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Sesion creada',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            loading.hide();
            this.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            });
          });
        }, (error) => {
          loading.hide();
          this.errorModal.message = error;
          this.$bvModal.show(this.errorModal.id)
        });
      },
      validateForm() {
        return new Promise((resolve, reject) => {
          let error = false;
          let touchEval = false;
          let emptyEval = false;
          let emptyKpi = false;
          let emptyMinute = false;

          if (this.evaluations) {
            for (let obj of this.evaluations) {
              for (let e of obj.evaluations) {
                if (e.result_name !== null) {
                  touchEval = true;
                  break;
                }
              }
              if (touchEval) {
                for (let e of obj.evaluations) {
                  if (e.result_name == null) {
                    emptyEval = true;
                    break;
                  }
                }
              }
              if (touchEval && emptyEval) {
                break;
              }
            }
          }

          if (this.kpiext) {
            for (let k of this.kpiext) {
              if (k.value == null) {
                emptyKpi = true;
                break;
              }
            }
          } 

          let message = 'Debe evaluar todas las ';
          if (touchEval && emptyEval) {
            error = true;
            message += 'Conductas '
          }
          if (emptyKpi) {
            error = true;
            message += 'y KPIs'
          }

          if (this.minute == null ) {
            emptyMinute = true;
            message += ' , ademas de completar la minuta.'
          }

          if (error) {
            reject(message);
          } else {
            resolve();
          }
        });
      }
    }
  };
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>


// WEBPACK FOOTER //
// src/views/consultor-externo/modals/modal-session.vue